/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { userListHeaderStyles } from "@monsma/Overrides/Widgets/UserList/UserListHeader";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

userListHeaderStyles.titleGridItem = {
    width: [10, 12, 12, 12, 12],
};

userListHeaderStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;

        ${screen("lt", "sm")} {
            position: absolute;
            top: 0;
            right: 0;
            padding: 5px 0;
        }
    `,
    width: [2, 2, 4, 4, 4],
};

userListHeaderStyles.searchGridItem = {
    width: [12, 10, 8, 8, 8],
};

userListHeaderStyles.searchForm = {
    css: css`
        display: flex;
        justify-content: flex-start;
        width: 100%;

        ${screen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

userListHeaderStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 1 auto;
            margin-right: 1rem;
            max-width: 262px;

            ${screen("lt", "sm")} {
                width: 100%;
                max-width: 100%;
                margin: 0;
                margin-bottom: 15px;
            }
        `,
    },
    iconProps: { src: "Search" },
};

userListHeaderStyles.searchSubmitButton = {
    css: css`
        flex: 0 0 auto;

        ${screen("lte", "sm")} {
        }
    `,
    variant: "secondary",
};

userListHeaderStyles.userCountText = {
    css: css`
        margin-bottom: 0;
    `,
};
